import api from "./api";

const API_PREFIX = "api/patient";

/**
 * Fetch residence list (no pagination).
 * @param {Object} params - activeFacilities (array), type, fromdate, todate, transfertype, admissionType, search
 * @returns {Promise<{ data: Array, total: number }>}
 */
export const getResidenceList = async (params = {}) => {
  const {
    activeFacilities,
    type,
    fromdate,
    todate,
    transfertype,
    admissionType,
    search,
  } = params;

  const query = new URLSearchParams();
  if (Array.isArray(activeFacilities) && activeFacilities.length > 0) {
    activeFacilities.forEach((id) => query.append("activeFacilities", id));
  }
  if (type) query.set("type", type);
  if (fromdate) query.set("fromdate", fromdate);
  if (todate) query.set("todate", todate);
  if (transfertype) query.set("transfertype", transfertype);
  if (admissionType) query.set("admissionType", admissionType);
  if (search && search.trim()) query.set("search", search.trim());

  // api interceptor already returns response.data
  // Backend returns: { data: [], total, ninetyDaysData }
  const payload = await api.get(`${API_PREFIX}/residence-list?${query.toString()}`);

  if (payload && typeof payload === "object" && Array.isArray(payload.data)) {
    return payload;
  }

  // Fallback for older shape (plain array)
  if (Array.isArray(payload)) {
    return { data: payload, total: payload.length, ninetyDaysData: [] };
  }

  return { data: [], total: 0, ninetyDaysData: [] };
};
